import React from "react";
import { FormCamposProps } from "./FormCamposProps";
import Grid, { GridItem } from "@/components/layout/Grid";
import CampoTexto from "@/components/Formulario/CampoTexto";
import CampoSenha from "@/components/Formulario/CampoSenha";

export const FormCamposInstagram = ({
    value,
    onChange,
    fieldErrors,
}: FormCamposProps) => {
    return null;
};